// export const API_URL = 'https://ramapharma-api-mirror.beetronix.com/api'
// export const API_URL = 'https://mirror-api.octopharma.net/api'  
// export const API_URL = 'https://mirror2-api.octopharma.net/api'
// export const API_URL = 'https://mirta-mirror-api.octopharma.net/api'

// export const API_URL = 'https://olabi-mirror-api.octopharma.net/api'

// export const API_URL = 'https://api.ibn-alhaytham.octopharma.net/api'    
// export const API_URL = 'https://api.goldenpharma.octopharma.net/api'

// export const API_URL = 'https://api.oubari.octopharma.net/api'

// export const API_URL = 'https://api.mirta.octopharma.net/api'
export const API_URL = 'https://api.olabi.octopharma.net/api'

// export const API_URL = 'https://api.company.octopharma.net/api'

// export const API_URL = 'https://api.alkhalil.octopharma.net/api'
// export const API_URL = 'https://api.barakat.octopharma.net/api'
// 
export const VERSION = '5.0.5'
// 